import { AddBikeErrorProps } from "../features/BikeCollectionImport"
import { BikeImport } from "../models"
import {
  isPrivateOwner,
  isCompanyOwner,
  isOwnerByConsumerId,
  isTypeValid,
  isBrandValid,
  isModelValid,
  isEngineNumberValid,
  isBatteryNumberValid,
  isOwnerExist,
  isNoMultipleOwners,
  isOwnerValid,
  isBikeValid
} from "../utils/bikeValidation"

const createOwner = (bike: BikeImport) => {
  if(isPrivateOwner(bike)) return bike.bike_owner.private_owner
  if(isCompanyOwner(bike)) return bike.bike_owner.company_owner
  if(isOwnerByConsumerId(bike)) return bike.bike_owner.owner_by_id
  return bike.bike_owner
}

type filterManuallyCheckedBikeCollectionProps = {
  bikes: BikeImport[],
  addBikeError: ({ bike, errorTextArr }: AddBikeErrorProps) => void
}

export const filterManuallyCheckedBikeCollection = ({ bikes, addBikeError }: filterManuallyCheckedBikeCollectionProps) => {
  return bikes
    .filter((bike: BikeImport) => {
        // validate bike description
        return isTypeValid(bike, addBikeError)
          && isBrandValid(bike, addBikeError)
          && isModelValid(bike, addBikeError)
          && isEngineNumberValid(bike, addBikeError)
          && isBatteryNumberValid(bike, addBikeError)
      })
      /*
        AJV cannot handle owner validation since data should be validated
        against multiple JSON schemas (AJV only manage validation against a single schema):
        Currently in the main schema (src\pages\protected\BikeCollectionImport\schema.js) we have 3 schemas that describe the owner.
        See https://ajv.js.org/json-schema.html#oneof
      */
      .filter((bike) => isOwnerExist(bike, addBikeError))
      .filter((bike) => isNoMultipleOwners(bike, addBikeError))
      .map((currBike) => ({
        ...currBike,
        bike_owner: createOwner(currBike)
      }))
      .filter((bike) => isOwnerValid(bike, addBikeError))
}

export const delegateBusinessLogicFilter = (bikes: BikeImport[], schema, addBikeError: ({ bike, errorTextArr }: AddBikeErrorProps) => void) => {
  return bikes.filter(bike => isBikeValid(schema, bike, addBikeError))
}